import React from 'react';
import './articles.css';

const ArticlesPage = () => (
  
    <div className="">
		<p className="article-header">Writers on the art of a short story</p>
		<div className="article-quote">
		<div className="left-text">
		<p>'Every good story is at least two stories, and we read on because we're watching the buried one come to the surface'</p>
		<a 
		href='https://www.booktrust.org.uk/books-and-reading/tips-and-advice/writing-tips/writing-tips-from-authors/david-vanns-advice-on-writing-short-stories/'
		className="article-author"
		rel="noopener noreferrer"
		target="_blank">
		David Vann on the protagonist/antagonist
		</a>
		</div>
		</div>
		
		<div className="article-quote">
		<div className="right-text">
		<p>'Cheever is a writer who helped teach me to think about characters like a sphere: You’ve got the north pole and the south pole, a polarity with opposite charges contained inside one whole. But then there’s these magnetic fields created between the two of them, which is where the real complexity is'</p>
		<a 
		href='https://www.theatlantic.com/entertainment/archive/2013/09/think-about-characters-like-a-sphere-how-john-cheever-wrote-inner-turmoil/279541/'
		className="article-author"
		rel="noopener noreferrer"
		target="_blank">
		Novelist Paul Harding on John Cheever's The Jewel of the Cabots
		</a>
		</div>
		</div>

		<div className="article-quote">
		<div className="left-text">
		<p>'As writers, by understanding that it is not our job to solve our hero’s problem (it’s unsolvable!) but rather, to inquire into the resolution of the dilemma, our story becomes instantly dynamic. Our focus shifts, and we begin to see the story in a whole new way'</p>
		<a 
		href='https://lawriterslab.com/dilemma-heart-story/'
		className="article-author"
		rel="noopener noreferrer"
		target="_blank">
		Alan Watt, author of 'The 90-day Novel', on the dilemma at the heart of your story
		</a>
		</div>
		</div>

		<div className="article-quote">
		<div className="right-text">
		<p>'When writers reread their own work, there is a tendency to see the story not as it actually is on the page but as it is in their head. That is the inexperienced writer uses the words on the page as triggers, as reminders, of the original vision in their head'</p>
		<a 
		href='https://stingingfly.org/2017/10/24/edit-lousy-writing/'
		className="article-author"
		rel="noopener noreferrer"
		target="_blank">
		Julian Gough on how to edit your own lousy writing, from TheStingingFly
		</a>
		</div>
		</div>

		<div className="article-quote">
		<div className="left-text">
		<p>'The resulting story can never be what was first imagined. It is absurd to believe it could, but if writers didn’t persist in believing this, they would quit (or admit to their being masochists). Instead, writers learn to work in graduations of failure'</p>
		<a 
		href='https://stingingfly.org/2015/11/01/the-page-as-existence/'
		rel="noopener noreferrer"
		className="article-author"
		target="_blank">
		Hugh Fulham-McQuillan on The Page As Existence, from The StingingFly
		</a>
		</div>
		</div>

		<div className="article-quote">
		<div className="right-text">
		<p>'Any work of art quickly reveals itself to be a linked system of problems. A book has personality, and personality, as anyone burdened with one will attest, is a mixed blessing. Almost from the first paragraph, the writer becomes aware that a work’s strengths and weaknesses are bound together, and that, sadly, his great idea has baggage'</p>
		<a 
		href='https://www.theguardian.com/books/2017/mar/04/what-writers-really-do-when-they-write'
		rel="noopener noreferrer"
		className="article-author"
		target="_blank">
		George Saunders on What Writers Really Do When they write, in an interview with The Guardian 
		</a>
		</div>
		</div>
    </div>
 
);

export default ArticlesPage;